

export const environment = {
  production: false,
  authApiUrl: '/api/auth',    // proxy handles this
  dataApiUrl: '/api/data',     // proxy handles this
  builderApiKey: 'fd4814467bb54a6da123213a976892e2'
};
